import { render, staticRenderFns } from "./ContentFeedBaseView.vue?vue&type=template&id=c24c70a6&scoped=true&"
import script from "./ContentFeedBaseView.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedBaseView.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedBaseView.vue?vue&type=style&index=0&id=c24c70a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24c70a6",
  null
  
)

export default component.exports